const translation = {
  1033: 'Inventario',
  1034: 'Negozio',
  1530: 'Hai già un abbonamento',
  1531: 'Sei sicuro di voler acquistare un abbonamento?',
  1532: "Costerà <img src='/svgs/dominion.svg' style='margin: 0px 10px -10px 10px'/> {{ param1 }}?",
  1533: "Apri un <span style='color: #FF9326;font-size: 28px'>NEGOZIO PERSONALE</span> </br>per la tua struttura di giocatori",
  1534: "Affittare per <img src='/svgs/loyaltyIcon.svg' style='margin: 0px 0px -5px 2px; width: 20px'/> {{ param1 }} Loyalty Coin?",
  1535: 'Sei sicuro di voler affittare l’Hexatile #{{ param1 }}?',
  1536: "Costerà <img src='/svgs/loyaltyIcon.svg' style='margin: 0px 0px -3px 2px'/> {{ param1 }} Loyalty Coin",
  1537: 'L’affitto verrà addebitato ogni 30 giorni',
  1538: 'Sei sicuro di voler selezionare questo Consulente?',
  1539: "Il servizio <span style='color: #FF9326'>Territory X</span> <span style='color: #FF9326'>NON</span> si applica alle aree in affitto.",
  1540: 'Hai scelto di affittare {{ param1 }} Hexatiles',
  1541: 'Necessario per l’affitto',
  1542: '2 anni',
  1543: 'L’Hexatile #{{ param1 }} è affittato',
  1544: 'Puoi vederlo sulla mappa nel dominio 2 del Consulente',
  1545: 'Sei sicuro di voler selezionare questo Consulente?',
  1546: 'Il servizio Territory X NON si applica alle aree in affitto.',
  1547: 'Sei sicuro di voler posizionare un Orb su un Hexatile in affitto?',
  1548: 'Se l’affitto termina, l’orb non ti apparterrà più.',
  1549: '({{ param1 }} in affitto)',
  1550: 'Hexatiles in affitto',
  1551: 'Sei sicuro di voler spostare / vendere l’ultimo Hexatile?',
  1552: 'Se in questo Consulente non resta alcun Hexatile, entrerà in IBERNAZIONE. Può restare vuoto per 7 giorni, dopodiché verrà distrutto.',
  1553: 'Non c’è nemmeno un Hexatile (affittato o acquistato) in questo Consulente.',
  1554: 'Può restare vuoto in stato di ibernazione per 7 giorni, dopodiché verrà distrutto.',
  1555: 'Riempi il Consulente con Hexatiles (acquista o affitta) per farlo uscire dall’ibernazione.',
  1556: 'Puoi ottenere Loyalty Coin accedendo a Masters of Game ogni giorno e completando le missioni (prossimamente)',
  1557: 'Loyalty Coin è una moneta speciale pensata per affittare appezzamenti di terreno in Legends Of Interaction. La moneta può essere usata solo da un Master of Game. Puoi ottenere Loyalty Coin accedendo a Masters of Game ogni giorno e completando le missioni (prossimamente)',
  1558: '{{ param1 }} è rimasto vuoto ed è entrato in IBERNAZIONE per 7 giorni.',
  1559: ' Riempilo con Hexatiles (acquista o affitta), altrimenti verrà distrutto.',
  1560: 'Non c’è nemmeno un Hexatile (affittato o acquistato) in questo Consulente.',
  1561: 'Può restare vuoto in stato di ibernazione per 7 giorni, dopodiché verrà distrutto.',
  1562: 'Riempi il Consulente con Hexatiles (acquista o affitta) per farlo uscire dall’ibernazione.',
  1563: 'Benvenuto in <br/> MASTERS OF GAME',
  1564: "Ricompense del <span style='color: #FF9326'>GIORNO {{ param1 }}</span> :",
  1565: "Ricompense della <span style='color: #FF9326'>SETTIMANA</span> :",
  1566: "Ricompense del <span style='color: #FF9326'>MESE</span> :",
  1567: "<span style='color: #FF9326'>{{ param1 }}</span> Hexatiles <br/> spostati con successo.",
  1568: "Puoi vederlo sulla mappa nel dominio <span style='color: #FF9326'>{{ param2 }}</span>.",
  1569: 'Non attivato',
  1570: 'Sei sicuro di voler attivare / aggiornare Territory X?',
  1571: 'Sei sicuro di voler annullare questo acquisto?',
  1572: "Questa azione terminerà l’asta e le informazioni sull’hexatile torneranno nella scheda «<span style='color: #FF9326'>World</span>»",
  1573: 'Sì, voglio annullare l’acquisto',
  1574: 'No, torna alle offerte',
  1575: 'Puoi vedere e posizionare gli Orb solo con ZOOM 19 o superiore.',
  1576: "Per favore, <span style='color: #FF9326'>ingrandisci</span> la mappa.",
  1577: 'Gli Orb possono essere posizionati solo su Hexatiles acquistati.',
  1578: 'Seleziona un Hexatile che ti appartiene.',
  1579: 'I tuoi ordini di VENDITA verranno rimossi automaticamente dopo 10 giorni se non ci saranno offerte di acquisto.',
  1580: 'Guarda sulla mappa per vedere i dettagli.',
  1581: 'Restano {{ param1 }} giorni',
  1582: 'Il tuo ordine di VENDITA verrà rimosso automaticamente dopo 10 giorni se non ci saranno offerte di acquisto',
  1583: "L’Hexatile #{{ param1 }} è stato venduto per <img src='/svgs/reex.svg' style='margin: 0px 5px -10px 3px'/> {{ param2 }}",
  1584: 'Questa opportunità è disponibile solo per i partecipanti del focus group. <br/> Se ti interessa, contatta la persona che ti ha invitato qui.',
  1585: 'Codici referral:',
  1586: 'I codici si aggiornano automaticamente dopo l’attivazione.',
  1587: 'Non disponibile',
  1600: 'Disponibile: {{param1}}',
  1601: 'Clicca per posizionare',
  1602: 'Ingrandisci fino al livello {{param1}} per posizionare un miner',
  1603: 'Ancora nessun miner',
  1604: 'Miner',
  1605: 'Disponibile da raccogliere',
  1606: 'Totale raccolto',
  1607: 'Ultima raccolta',
  1608: 'Il miner è pieno e si è fermato. Raccogli i REEX per farlo continuare a minare',
  1609: 'Clicca per raccogliere',
  1610: 'Non c’è ancora nulla da raccogliere',
  1611: 'I miei maestri',
  1612: 'Il mio negozio',
  1613: 'LOI Referral',
  1614: 'Modelli',
  1615: 'Crea',
  1616: 'Anteprima',
  1617: 'Abbonamento',
  1618: 'È richiesto l’abbonamento al negozio',
  1619: 'Per possedere un negozio è necessario un abbonamento attivo da market maker.',
  1620: 'Vai all’abbonamento',
  1621: 'Ancora nessun modello',
  1622: 'Crea il primo',
  1623: 'Ecco come gli acquirenti vedono il tuo negozio',
  1624: 'Nessun modello è in vendita: gli acquirenti vedono un negozio vuoto',
  1625: 'Abbonamento al negozio',
  1626: 'L’abbonamento è attivo',
  1627: 'Nessun abbonamento',
  1628: 'Valido fino al {{param1}}',
  1629: 'Rinnova o acquista',
  1630: 'Acquista',
  1631: '1 anno',
  1632: '2 anni',
  1633: '3 anni',
  1634: '99 anni',
  1635: 'Acquistare l’abbonamento «{{param1}}» per {{param2}} {{param3}}?',
  1636: 'Il pagamento dell’abbonamento sarà disponibile a breve',
  1637: 'In vendita: {{param1}}',
  1638: 'Non in vendita',
  1639: '{{param1}} articoli',
  1640: 'Descrizione',
  1641: 'Prezzo',
  1642: 'In vendita: {{param1}}',
  1643: 'Non in vendita',
  1644: 'Contenuto del modello ({{param1}})',
  1645: 'Il pacchetto è vuoto.',
  1646: 'Elimina',
  1647: 'Prezzo (Reex)',
  1648: 'In vendita',
  1649: 'Salva',
  1650: 'Ritira dalla vendita',
  1651: 'Crea un modello',
  1652: 'Orb',
  1653: 'Monete',
  1654: 'Qui è vuoto',
  1655: 'Immagine del modello',
  1656: 'Carica immagine',
  1657: 'Cambia immagine',
  1658: 'Nome del modello',
  1659: 'Nel modello ({{param1}})',
  1660: 'Annulla',
  1661: 'Creazione...',
  1662: 'Troppi',
  1663: 'Ancora nessuna offerta',
  1664: 'Acquisto non disponibile',
  1665: 'Sei un market maker.',
  1666: 'Rimasti: {{param1}}',
  1667: 'Venditore',
  1668: 'Prezzo per pacchetto',
  1669: 'Contenuto del pacchetto ({{param1}})',
  1670: 'Nessun dato sul contenuto.',
  1671: 'Quantità',
  1672: 'Totale',
  1673: 'Anteprima: acquisto non disponibile',
  1674: 'Acquistato: {{param1}} ×{{param2}}',
  1675: 'Acquistare «{{param1}}» ×{{param2}} per {{param3}} Reex?',
  1676: 'Adesioni:',
  1677: 'Quantità (± in vendita)',
  1678: 'Aggiungi alla vendita',
  1679: 'Metti in vendita',
  1680: 'Ricompensa raccolta',
  1681: 'Raccolto: {{param1}} REEX',
  1682: 'Da',
  1683: 'A',
  1684: 'Mostra',
  1685: 'Esporta CSV',
  1686: 'Risorsa',
  1687: 'Transazioni',
  1688: 'Report',
  1689: '{{param1}} anno',
  1690: '{{param1}} anni',
  1691: 'Il periodo verrà aggiunto alla tua data di scadenza attuale.',
  1692: 'Dopo questo acquisto diventerai un market maker e uscirai dalla tua struttura attuale.',
  1693: 'Acquista Dominion',
  1694: 'QUANTITÀ',
  1695: 'VALUTA DI PAGAMENTO',
  1696: 'Presto',
  1697: 'Saldo: {{param1}}',
  1698: 'Criptovaluta',
  1699: 'Rete {{param1}}',
  1700: 'Totale:',
  1701: '{{param1}} NON SUFFICIENTE',
  1702: 'ACQUISTA {{param1}} {{param2}}',
  1703: 'Tasso: {{param1}} REEX per 1 {{param2}}. Altri metodi di pagamento verranno aggiunti in seguito.',
  1704: 'Acquistato {{param1}} {{param2}}',
  1705: 'Acquistare {{param1}} {{param2}} per {{param3}}?',
  1706: 'Offerte personali',
  1707: 'Un prezzo speciale per un certo numero di pacchetti destinato a un giocatore specifico della tua struttura. Le offerte personali vengono applicate prima del prezzo normale e spariscono una volta esaurite.',
  1708: 'Giocatore',
  1709: 'Nessuna offerta personale per questo modello',
  1710: 'Aggiungi',
  1711: 'Rimuovere l’offerta personale per {{param1}}?',
  1712: 'Prezzo personale',
  1713: 'Prezzo personale per i primi {{param1}} pacchetti',
  1714: '{{param1}} a prezzo personale, {{param2}} a prezzo normale',
  1715: 'Vendita',
  1716: 'Giocatore #{{param1}}',
  1717: 'Personali: {{param1}}',
  1718: 'Caricamento del tasso…',
  1719: 'Impossibile caricare il tasso di cambio. L’acquisto non è temporaneamente disponibile.',
  1720: 'Riprova',
  1721: 'TASSO NON DISPONIBILE',
  1722: 'Link di referral',
  1723: 'Ottenere maestri',
  1724: 'Maestri del Gioco',
  1725: 'In questa sezione potrete richiedere di ricevere i Maestri del Gioco attraverso campagne pubblicitarie globali. Per effettuare una richiesta, dovrete inviare uno speciale token 1GM al vostro indirizzo interno destinato alla ricezione delle risorse. Per maggiori informazioni su 1GM, rivolgetevi ai vostri Market maker di livello superiore.',
  1726: 'Illimitato',
  1727: 'Valido per sempre',
  1728: 'Hai un abbonamento illimitato: non c’è altro da acquistare.',
  1729: 'Ottenete i vostri Maestri del Gioco personali attraverso una campagna pubblicitaria globale',
  1730: 'Potete richiedere per voi stessi la registrazione di',
  1731: 'Richiedere',
  1732: 'La possibilità di richiedere la registrazione dei Maestri del Gioco sarà attivata in seguito.',
  1733: 'Ingrandisci fino al livello {{param1}} per spostare gli orb',
  1734: '1GM è un token speciale usato per richiedere la registrazione dei Maestri del Gioco attraverso campagne pubblicitarie globali. Per saperne di più su 1GM, rivolgetevi ai vostri Market maker di livello superiore.',
  1735: 'ASSISTENZA',
  1736: 'Nuovo ticket',
  1737: 'Oggetto',
  1738: 'Messaggio',
  1739: 'Crea ticket',
  1740: 'Non hai ancora ticket',
  1741: 'Torna ai ticket',
  1742: 'Scrivi una risposta',
  1743: 'Rispondi',
  1744: 'Aperto',
  1745: 'Chiuso',
  1746: 'Assistenza',
  1747: 'Tu',
  1748: 'Questo ticket è chiuso, non puoi più rispondere.',
  1749: 'Annulla',
  1750: 'Non ci sono ancora messaggi in questo ticket',
  1751: 'Risposto',
  1752: 'ORB',
  1753: 'R-ORB',
  1754: 'R-ORB MAP',
  1755: 'REEX MINER',
  1756: 'Oggetto',
  1757: 'Questa sezione è disponibile solo per i market maker',
  1758: 'Colpisci un drone e ottieni {{param1}} Loyalty coins. Ogni colpo costa {{param2}} Loyalty coin.',
  1759: 'Registrati per partecipare',
  1760: 'Ricarica il tuo saldo per continuare',
  1761: 'Ricarica',
  1762: 'Prezzo in altre valute',
  1763: 'Per raccogliere devi accumulare almeno {{param1}} REEX',
  1764: 'Polso',
  1765: 'Polso del negozio',
  1766: 'Il fatturato e tutto ciò che lo spiega. Questa schermata risponde alla domanda «perché pago l’abbonamento».',
  1767: 'RICAVI, ULTIMO MESE',
  1768: '{{param1}} vendite',
  1769: 'LA SUA POSIZIONE',
  1770: 'su {{param1}} negozi nell\'ultimo mese',
  1771: 'nessuna vendita nell\'ultimo mese',
  1772: 'TERRE VUOTE',
  1773: 'terreni dei Suoi master senza alcun oggetto',
  1776: 'CAPACITÀ',
  1777: 'tanti pacchetti sono in vendita in questo momento',
  1785: 'Master con terre vuote',
  1787: 'Le analisi appariranno quando il server inizierà a fornirle',
  1790: 'Ancora nessun dato',
  1793: '{{param1}} terreni vuoti su {{param2}}',
  1794: 'Tutte le terre dei Suoi master sono edificate',
  1795: 'Classifica vendite, ultimo mese',
  1796: 'classifica anonima di tutti i negozi per vendite nel periodo',
  1797: 'Il Suo negozio',
  1798: 'I miei dati',
  1799: 'Classifica',
  1800: 'Si può mettere in vendita: {{param1}}',
  1801: 'Massimo {{param1}} con gli asset attuali',
  1802: 'Asset insufficienti per mettere in vendita di più',
  1803: 'Negozio',
  1804: 'Le mie richieste',
  1805: 'Richieste',
  1806: 'Comunichi al Suo market maker di cosa ha bisogno',
  1807: 'Nuova richiesta',
  1808: '{{param1}} di {{param2}} richieste',
  1809: 'Ancora nessuna richiesta',
  1810: 'Pacchetti: {{param1}}',
  1811: '{{param1}} Reex a pacchetto',
  1812: 'Totale: {{param1}} Reex',
  1813: 'Scelga cosa vuole comprare',
  1814: 'Nella richiesta ({{param1}})',
  1815: 'Ancora niente di selezionato',
  1816: 'Numero di pacchetti',
  1817: 'Prezzo a pacchetto (Reex)',
  1818: 'Crea richiesta',
  1819: 'Richieste dei Suoi master',
  1820: 'I Suoi master non hanno ancora richiesto nulla',
  1821: 'Chiudi richiesta',
  1822: 'Limite raggiunto: elimini una richiesta per crearne una nuova',
  1823: 'Nessuna risorsa disponibile per le richieste',
  1824: 'Cosa vogliono comprare i Suoi master. Chiuda la richiesta quando è evasa.',
  1825: 'Il gioco è in beta iniziale',
  1826: 'Legends of Interactions è in una fase iniziale di sviluppo. Funzioni e contenuti vengono ancora aggiunti e possono cambiare da una versione all\'altra.',
  1827: 'La versione attuale del gioco è disponibile sul sito ufficiale',
  1828: 'Scarica il gioco',
  1829: 'Codici di invito a LOI',
  1830: 'ACCUMULATO',
  1831: 'Clicchi sull\'orb per raccogliere',
  1832: 'Non si è ancora accumulato nulla',
  1833: 'Extra',
  1834: 'Funzioni speciali del gioco',
  1835: 'Emulatori di giocatori',
  1836: 'Colleghi un emulatore a un consigliere e raccoglierà risorse per Lei.',
  1837: 'EMULATORI LIBERI',
  1838: 'Collega emulatore',
  1839: 'Attivo',
  1842: 'Nessun emulatore libero',
  1843: 'Collegare un emulatore al consigliere «{{param1}}»?',
  1844: 'L\'emulatore inizierà a raccogliere risorse per questo consigliere.',
  1847: 'Non ha ancora consiglieri',
  1848: 'Esagoni: {{param1}} / {{param2}}',
  1851: 'Principale',
  1852: 'Attivo dal {{param1}}',
  1853: 'BATTERIA',
  1854: 'Restituisci all\'inventario',
  1855: 'Restituire all\'inventario l\'emulatore del consigliere «{{param1}}»?',
  1856: 'L\'emulatore smetterà di raccogliere risorse e tornerà libero.',
}

export default translation
